import styled from 'styled-components';
import BgBanner from '../../Images/Provisorio/Banner2.jpg';
import BgBannerResp from '../../Images/Provisorio/BannerResp.jpg';

export const Bgbanner = styled.div`
  width: 100%;
  background-image: url(${BgBanner});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 9%;
  background-color: #0d0804;
  padding: 40px 0; 

    &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 30%; /* ajuste como quiser */
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.55) 117%
    );
    pointer-events: none;
  }

  .ForaBanner {
    width: 60%;
    max-width: 770px;
    margin: 0 auto;
    text-align: center;

    .ImgLogo {
      width: 100%;
      height: auto;
      margin-bottom: 20px; 
      margin-top: -40px;
    }
  }

  @media (max-width: 800px) {
    background-image: url(${BgBannerResp});

    .ForaBanner {
      width: 95%;
    }
  }
`;

export const BaixoProv = styled.div`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -150px;

  h1 {
    font-family: "Fugaz One", sans-serif;
    font-weight: 400;
    font-size: 35px;
    color: #ffd05e;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: #fff;
  }

  .Tel {
    font-size: 25px;
    border-radius: 12px;
    border: 2px solid #ffd05e;
    width: 250px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 3px;
    margin-top: 10px;
  }

  .Mail {
    font-size: 17px;
    letter-spacing: 3px;
        padding-top: 17px;
    margin-bottom: 45px;
    cursor: pointer;
  }

  .ForaIcon {
    display: flex;
    width: 170px;
    justify-content: space-between;

    img {
      width: auto;
      margin-bottom: auto;
      cursor: pointer;
    }
  }

    @media (max-width: 1100px) {
        margin-top: -13vw;
    }

    @media (max-width: 550px) {
        margin-top: -20vw;
    }
  
`;

